import { combineReducers } from 'redux';
import { reducer as notificationsReducer } from 'reapop';
import { i18nReducer } from 'react-redux-i18n';
import customNotificationReducer from './notifications/notificationReducer';
import shoppingCenterReducer from './shopping-centers/ShoppingCentersReducer';
import dynamicKeysReducer from './dynamic-keys/dynamicKeysReducer';
import officesReducer from './offices/officesReducer';
import pageReducer from './page/pageReducer';
import googleServicesReducer from './google-services/googleServicesReducer';
import storeReducer from './stores/storeReducer';

export default combineReducers({
  page: pageReducer,
  shoppingCenterFilters: shoppingCenterReducer,
  i18n: i18nReducer,
  notifications: notificationsReducer(),
  customNotification: customNotificationReducer,
  dynamicKeys: dynamicKeysReducer,
  office: officesReducer,
  store: storeReducer,
  google: googleServicesReducer,
});
